// extracted by mini-css-extract-plugin
module.exports = {"title":"chatting_title__30xUW","container":"chatting_container__3nqN6"};